"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputContainer = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@itwin/itwinui-css/css/utils.css");
/**
 * Input container to wrap inputs with label, and add optional message and icon.
 * @private
 */
const InputContainer = (props) => {
    var _a;
    const { as: Element = 'div', label, disabled, required, status, message, icon, isLabelInline, isIconInline, children, className, style, statusMessage, inputId, labelId, ...rest } = props;
    const LabelElement = inputId && Element !== 'label' ? 'label' : 'div';
    return (React.createElement(Element, { className: (0, classnames_1.default)('iui-input-container', {
            'iui-disabled': disabled,
            [`iui-${status}`]: !!status,
            'iui-inline-label': isLabelInline,
            'iui-inline-icon': isIconInline,
            'iui-with-message': (!!message || !!icon || !!statusMessage) && !isLabelInline,
        }, className), style: style, ...rest },
        label && (React.createElement(LabelElement, { className: (0, classnames_1.default)('iui-label', {
                'iui-required': required,
            }), htmlFor: inputId, id: labelId }, label)),
        children,
        statusMessage ? (statusMessage) : (React.createElement(React.Fragment, null,
            icon &&
                React.cloneElement(icon, {
                    className: (0, classnames_1.default)('iui-input-icon', (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className),
                }),
            message && !isLabelInline && (React.createElement("div", { className: 'iui-message' }, message))))));
};
exports.InputContainer = InputContainer;
